import { WPTaxonomy } from '@/types'

export const normalizeCollectionData = (
  collectionData: any,
  show_link: boolean
) => {
  return collectionData.map((item: any) => {
    return {
      id: item.id,
      type: item.type || 'taxonomy',
      link: show_link
        ? {
            url: item.link,
            title: item.title?.rendered || item.name,
            target: '_self'
          }
        : null,
      title: item.title?.rendered || item.name,
      paragraph: item.acf?.role || item.description,
      image: item.featured_image,
      icon: item.acf?.icon,
      color: item.acf?.bgcolor
    }
  })
}

export const normalizeAncestorTaxonomyData = (pageProps: any, strings: any) => {
  return {
    ...pageProps.object,
    wpml_translations: pageProps.wpml_translations,
    acf: {
      sections: [
        ...(pageProps?.object.acf?.sections || []),
        { acf_fc_layout: 'spacer', variant: 'sm' },
        {
          acf_fc_layout: 'buttons_group',
          items: [
            strings?.links?.all_products_lines?.url
              ? {
                  link: {
                    title: strings.links.all_products_lines.title,
                    url: strings.links.all_products_lines.url
                  }
                }
              : null,
            ...pageProps.objects.map((tax: WPTaxonomy) => ({
              link: {
                title: tax.name,
                url: tax.link
              }
            }))
          ].filter((item) => item !== null)
        },
        { acf_fc_layout: 'spacer', variant: 'md' },
        {
          acf_fc_layout: 'grid_post_types',
          post_type: 'product-category',
          use_filter: true,
          filter_type: 'static',
          static_filter: pageProps.object,
          use_pagination: false,
          per_page: 4,
          show_link: true,
          headers: pageProps.children.headers,
          collection: pageProps.children.collection
        },
        { acf_fc_layout: 'spacer', variant: 'xxl' }
      ]
    }
  }
}

export const normalizeChildrenTaxonomyData = (pageProps: any) => {
  return {
    ...pageProps.object,
    wpml_translations: pageProps.wpml_translations
  }
}

export const normalizeHeadData = (pageProps: any) => {
  if (pageProps.type === 'taxonomy') {
    return {
      ...pageProps.object,
      wpml_translations: pageProps.wpml_translations
    }
  }
  return pageProps
}

export const mapOptionsDataProps = async (optionsData: any) => {
  return {
    ...optionsData
  }
}
